import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_comp_RowInterface {
  guid: string;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  abbreviation: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  tax_registration_id: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  comp_registration_num: fromDatatype.VarcharDatatypeInterface;
  modified_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  modified_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  chart_of_acc_guid: fromDatatype.GuidDataFieldInterface;
  tax_inclusive_output: boolean;
  tax_inclusive_input: boolean;
  default_tax_code_output: fromDatatype.GuidDataFieldInterface;
  default_tax_code_input: fromDatatype.GuidDataFieldInterface;
  sst_registration_id: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  sic_code: fromDatatype.VarcharDatatypeInterface;
  business_activity_desc: fromDatatype.TextDatatypeInterface;
  rounding_five_cent: boolean;
  rounding_item_guid: fromDatatype.GuidDataFieldInterface;
  group_discount_item_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_country: fromDatatype.VarcharDatatypeInterface;
  einvoice_mechanism: fromDatatype.VarcharDatatypeInterface;
  einvoice_batch_line_logic: fromDatatype.VarcharDatatypeInterface;
  default_timezone: fromDatatype.VarcharDatatypeInterface;
  einvoice_tax_id_no: fromDatatype.VarcharDatatypeInterface;
  gst_number: fromDatatype.VarcharDatatypeInterface;
  tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  atiga_number: fromDatatype.VarcharDatatypeInterface;
  fta_info: fromDatatype.VarcharDatatypeInterface;
  einvoice_default_payment_method_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_default_payment_method_json: any;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  default_purchase_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  default_sales_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  peppol_participant_id: fromDatatype.VarcharDatatypeInterface;
  peppol_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_id_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_id_value: fromDatatype.VarcharDatatypeInterface;
  einvoice_notification_methods_json: any;
  lhdn_env_type: fromDatatype.VarcharDatatypeInterface;
  state_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_send_email: boolean;
  einvoice_settings_json: fromDatatype.JsonDatatypeInterface;
  main_branch_guid: fromDatatype.GuidDataFieldInterface;
  fax_number: fromDatatype.VarcharDatatypeInterface;
  closing_date: fromDatatype.TimestampTzDatatypeInterface;
  company_inco_date: fromDatatype.TimestampTzDatatypeInterface;
  file_attachment_guid: fromDatatype.GuidDataFieldInterface;
  disable_consolidated_self_billed_submission: boolean;
  disable_consolidated_submission: boolean;
  disable_single_general_submission: boolean;
  enable_high_value_sales_validation: boolean;
}


export class bl_fi_mst_comp_RowCLass implements bl_fi_mst_comp_RowInterface {
  guid: string;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  abbreviation: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  tax_registration_id: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  comp_registration_num: fromDatatype.VarcharDatatypeInterface;
  modified_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  modified_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  chart_of_acc_guid: fromDatatype.GuidDataFieldInterface;
  tax_inclusive_output: boolean;
  tax_inclusive_input: boolean;
  default_tax_code_output: fromDatatype.GuidDataFieldInterface;
  default_tax_code_input: fromDatatype.GuidDataFieldInterface;
  sst_registration_id: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  sic_code: fromDatatype.VarcharDatatypeInterface;
  business_activity_desc: fromDatatype.TextDatatypeInterface;
  rounding_five_cent: boolean;
  rounding_item_guid: fromDatatype.GuidDataFieldInterface;
  group_discount_item_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_country: fromDatatype.VarcharDatatypeInterface;
  einvoice_mechanism: fromDatatype.VarcharDatatypeInterface;
  einvoice_batch_line_logic: fromDatatype.VarcharDatatypeInterface;
  default_timezone: fromDatatype.VarcharDatatypeInterface;
  einvoice_tax_id_no: fromDatatype.VarcharDatatypeInterface;
  gst_number: fromDatatype.VarcharDatatypeInterface;
  tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  atiga_number: fromDatatype.VarcharDatatypeInterface;
  fta_info: fromDatatype.VarcharDatatypeInterface;
  einvoice_default_payment_method_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_default_payment_method_json: any;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  default_purchase_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  default_sales_return_pricing_option: fromDatatype.VarcharArrayDatatypeInterface;
  peppol_participant_id: fromDatatype.VarcharDatatypeInterface;
  peppol_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_id_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_id_value: fromDatatype.VarcharDatatypeInterface;
  einvoice_notification_methods_json: any;
  lhdn_env_type: fromDatatype.VarcharDatatypeInterface;
  state_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_send_email: boolean;
  einvoice_settings_json: fromDatatype.JsonDatatypeInterface;
  main_branch_guid: fromDatatype.GuidDataFieldInterface;
  fax_number: fromDatatype.VarcharDatatypeInterface;
  closing_date: fromDatatype.TimestampTzDatatypeInterface;
  company_inco_date: fromDatatype.TimestampTzDatatypeInterface;
  file_attachment_guid: fromDatatype.GuidDataFieldInterface;
  disable_consolidated_self_billed_submission: boolean;
  disable_consolidated_submission: boolean;
  disable_single_general_submission: boolean;
  enable_high_value_sales_validation: boolean;
}
